import api from "./apiClient";

/**
 * Admin data dashboards (ASB-4377; API ASB-4376, design A.3). Read-only, and
 * Role.ADMIN only on the server: a non-admin gets a 403 the page shows as
 * "not available". The rows are precomputed daily by the abuilder
 * `admin_panels` DAG; nothing here queries Snowflake.
 */

/** GET /admin/panels: every published manifest with `latestDay` and `computedAt`, sorted by title. */
export async function getPanels() {
	const response = await api.get("/admin/panels");
	return response.json();
}

/**
 * GET /admin/panels/<panelId>/<datasetId>?from&to&region[&key=value]: the
 * dataset's rows over the range, shaped as A.3 says. `filters` are drill keys
 * (only keys some dataset's `drill.on` names for this target are accepted).
 * A `searchable` table (A.6) adds `q` (a substring over the text and url
 * columns), `sort`/`dir` (a manifest column, asc|desc) and `limit`/`offset`
 * (paging; the response then carries `total`).
 */
export async function getPanelDataset(
	panelId,
	datasetId,
	{ from, to, region, filters, q, sort, dir, limit, offset } = {}
) {
	const query = new URLSearchParams();
	if (from) query.set("from", from);
	if (to) query.set("to", to);
	if (region) query.set("region", region);
	Object.entries(filters ?? {}).forEach(([key, value]) => {
		if (value !== undefined && value !== null) query.set(key, String(value));
	});
	if (q) query.set("q", String(q));
	if (sort) query.set("sort", String(sort));
	if (sort && dir) query.set("dir", dir === "asc" ? "asc" : "desc");
	if (Number.isFinite(limit)) query.set("limit", String(limit));
	if (Number.isFinite(offset) && offset > 0) query.set("offset", String(offset));
	const qs = query.toString();
	const response = await api.get(
		`/admin/panels/${encodeURIComponent(panelId)}/${encodeURIComponent(datasetId)}${
			qs ? `?${qs}` : ""
		}`
	);
	return response.json();
}
